type Contact = {
  name?: string;
  title?: string;
  email?: string;
  linkedin_url?: string;
  phone?: string;
};

const enrichedContactAvatarPalette = ["#EAECF5", "#E0F2FE", "#E0EAFF", "#EBE9FE", "#FCE7F6", "#FEF0C7"];

const getInitials = (name?: string) => {
  const value = String(name || "").trim();
  if (!value) return "NA";
  const words = value.split(/\s+/).filter(Boolean);
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return `${words[0][0] || ""}${words[1][0] || ""}`.toUpperCase();
};

const getAvatarColor = (name?: string) => {
  const seed = String(name || "A")
    .split("")
    .reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return enrichedContactAvatarPalette[seed % enrichedContactAvatarPalette.length];
};

const EnrichedContactsPopover = ({ contacts = [] }: { contacts?: Contact[] }) => (
  <div className="tw-w-[396px] tw-max-h-[550px] tw-overflow-auto tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white tw-p-4 tw-pr-3 tw-shadow-xl">
    <div className="tw-flex tw-flex-col tw-gap-3 tw-min-w-full">
      {contacts.map((contact, index) => {
        const name = contact.name;
        const title = contact.title;
        const email = contact.email;
        const contactKey = email || name || index;
        const linkedinUrl = contact.linkedin_url;
        const phoneNumber = contact.phone;

        return (
          <div key={contactKey} className="tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white tw-px-3 tw-py-4 tw-shadow-sm">
            <div className="tw-flex tw-items-start tw-gap-2">
              <div className="tw-h-10 tw-w-10 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-sm tw-font-medium tw-text-gray-900 tw-shrink-0" style={{ backgroundColor: getAvatarColor(name) }}>
                {getInitials(name)}
              </div>
              <div className="tw-min-w-0">
                <div className="tw-text-sm tw-font-medium tw-text-gray-900 tw-break-words">{name}</div>
                {title ? <div className="tw-mt-1 tw-text-sm tw-text-gray-600 tw-break-words">{title}</div> : null}
                {email ? (
                  <a className="tw-mt-2 tw-text-sm !tw-text-primary-purple-600 tw-break-all hover:!tw-underline" href={`mailto:${email}`}>
                    {email}
                  </a>
                ) : null}
                {phoneNumber ? <div className="tw-mt-1 tw-text-sm tw-text-gray-600 tw-break-words">{phoneNumber}</div> : null}
                {linkedinUrl ? (
                  <div className="tw-mt-2 tw-text-sm tw-break-all">
                    <a href={linkedinUrl} target="_blank" rel="noopener noreferrer" className="tw-text-primary-purple-600 tw-underline tw-decoration-dashed tw-underline-offset-2 tw-decoration-primary-purple-200 hover:tw-text-primary-purple-700">
                      LinkedIn
                    </a>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  </div>
);

export default EnrichedContactsPopover;
